enum AppSettingName {
  DarkMode = 'DarkMode',
  DeveloperMode = 'DeveloperMode',
  InfuraAsDefault = 'InfuraAsDefault',
  MapStyle = 'MapStyle',
  PlayMapSettings = 'PlayMapSettings',
  RequestLocation = 'RequestLocation',
}

export default AppSettingName
